module.exports = __webpack_public_path__ + "img/heading-find.fa64bb97.svg";